import { render, staticRenderFns } from "./AppHeaderNotificationButton.vue?vue&type=template&id=6c60f013&scoped=true&"
import script from "./AppHeaderNotificationButton.vue?vue&type=script&lang=js&"
export * from "./AppHeaderNotificationButton.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderNotificationButton.vue?vue&type=style&index=0&id=6c60f013&prod&lang=less&scoped=true&"
import style1 from "./AppHeaderNotificationButton.vue?vue&type=style&index=1&id=6c60f013&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60f013",
  null
  
)

export default component.exports